import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { createPropertyType } from "../Services/APIService";

interface CreateCardProps {
  onCreateComplete: () => void;
  onCancel: () => void;
}

interface FormData {
  typeName: string;
}

const CreatePropertyType: React.FC<CreateCardProps> = ({
  onCreateComplete,
  onCancel,
}) => {
  const [formData, setFormData] = useState<FormData>({
    typeName: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const requiredField = <span className="text-danger ms-1">*</span>;

  const handleStateNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      typeName: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!formData.typeName.trim()) {
      setError("Please enter a valid Type Name");
      return;
    }

    try {
      setIsLoading(true);

      // Get user ID from localStorage
      const userId = localStorage.getItem("UserId");

      if (!userId) {
        throw new Error("User ID not found in localStorage");
      }

      // Prepare request payload
      const payload = {
        typeName: formData.typeName.trim().replace(/\s+/g, " "),
        isActive: true,
        tenantId: parseInt(localStorage.getItem("tenantId") || "0"),
        createdBy: parseInt(userId),
      };

      const result = await createPropertyType(payload);

      if (result.isCreated) {
        toast.success("Property Type Created Successfully!");
        // Reset form after successful submission
        setFormData({ typeName: "" });
        // Call the refresh function
        onCreateComplete();
      } else {
        throw new Error(result.message || "Failed to create state");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    onCancel();
    setFormData({ typeName: "" });
    setError(null);
  };

  return (
    <div className="card mb-4">
      
      <div className="card-header carHeaderWithBtn">
        <h5 className="card-title mb-0">Create Property Type</h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-danger text-danger" role="alert">
              {error}
            </div>
          )}
          <div className="row">
            <div className="col-12 col-lg-4 mb-3">
              <label htmlFor="typeName" className="form-label">
                Type Name{requiredField}
              </label>
              <input
                type="text"
                id="typeName"
                name="typeName"
                className="form-control form-control-lg"
                placeholder="Enter Type Name"
                value={formData.typeName}
                onChange={handleStateNameChange}
                required
              />
            </div>
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? "Creating..." : "Submit"}
              </button>
              <button
                type="button"
                className="btn btn-secondary mx-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePropertyType;
